const getEv = function () {
  let ev = ''
  wx.miniProgram.getEnv(function (res) {
    console.log(res.miniprogram) // true
    ev = res.miniprogram
  })
  return ev
}
const jumpUrl = function (url) {
  let hasParams = url.indexOf('?') >= 0
  if (hasParams) {
    url = url + '&token=' + localStorage.getItem('token')
  } else {
    url = url + '?token=' + localStorage.getItem('token')
  }
  location.href = url
}
export { getEv, jumpUrl }
